import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from "react"
import { MyContext } from "@/store/myContext"
import { maintainOrderReturnOne, maintainOrderReturnReview, maintainOrderReturnConfirm } from "@/service/ordersService"
import { MaintainOrdeReturnStatus } from "@/utils/enum"
import { Button, Modal, message, Table, Input } from "antd"
import { OperatorUserType } from "@/utils/enum.js"
export default ({ visible, setVisible, rowInfo }) => {
    const [list, setList] = useState([]) //列表
    const { t } = useTranslation();
    useEffect(() => {
        if (visible) {
            loadData()
        }
    }, [visible]) // eslint-disable-line react-hooks/exhaustive-deps

    //列表数据
    const loadData = () => {
        maintainOrderReturnOne(rowInfo.id).then((res) => {
            setList(res.retData.returnList)
        })
    }

    //table配置
    const columns = [
        {
            title: t(`ordersManage.repairReturnList.detail.商品编号`),
            align: "center",
            dataIndex: "materialCode",
        },
        {
            title: t(`ordersManage.repairReturnList.detail.商品名称`),
            align: "center",
            dataIndex: "materialName",
        },
        {
            title: t(`ordersManage.repairReturnList.detail.退回量`),
            align: "center",
            dataIndex: "returnNum",
        },
        {
            title: t(`ordersManage.repairReturnList.detail.申请人`),
            align: "center",
            dataIndex: "applicantUserName",
            render: (text, record) => {
                return text && `${OperatorUserType[record.applicantUserType]}--${text}`
            },
        },
        {
            title: t(`ordersManage.repairReturnList.detail.申请时间`),
            align: "center",
            dataIndex: "applicantTime",
        },
        {
            title: t(`ordersManage.repairReturnList.detail.审核人`),
            align: "center",
            dataIndex: "reviewerUserName",
            render: (text, record) => {
                return text && `${OperatorUserType[record.reviewerUserType]}--${text}`
            },
        },        {
            title: t(`ordersManage.repairReturnList.detail.审核时间`),
            align: "center",
            dataIndex: "reviewerTime",
        },
        {
            title: t(`ordersManage.repairReturnList.detail.入库人`),
            align: "center",
            dataIndex: "confirmUserName",
            render: (text, record) => {
                return text && `${OperatorUserType[record.confirmUserType]}--${text}`
            },
        },
        {
            title: t(`ordersManage.repairReturnList.detail.入库时间`) ,
            align: "center",
            dataIndex: "confirmTime",
        },
        {
            title: t(`ordersManage.repairReturnList.detail.状态`),
            align: "center",
            dataIndex: "status",
            render: (text, record) => {
                if (text === "reject") {
                    return `${t(`ordersManage.repairReturnList.detail.驳回`)}:${record.rejectInfo}`
                }
                return MaintainOrdeReturnStatus[text]
            },
        },
        {
            title: t(`ordersManage.repairReturnList.detail.操作`),
            align: "center",
            width: "240px",
            dataIndex: "id",
            render: (text, record) => {
                if (record.status === "tobe_review" && record.applicantUserType !== 1) {
                    return (
                        <>
                            <Button
                                type="primary"
                                size="small"
                                onClick={() => {
                                    handleReview(text, record, true)
                                }}
                                style={{ margin: "0 10px" }}
                            >
                                 {t(`ordersManage.repairReturnList.detail.通过`)}
                            </Button>
                            <Button
                                type="primary"
                                size="small"
                                danger
                                onClick={() => {
                                    handleReview(text, record, false)
                                }}
                                style={{ margin: "0 10px" }}
                            >
                                 {t(`ordersManage.repairReturnList.detail.驳回`)}
                            </Button>
                        </>
                    )
                } else if (record.status === "pending_storage") {
                    return (
                        <Button
                            type="primary"
                            size="small"
                            style={{ margin: "0 10px" }}
                            onClick={() => {
                                handleConfirmReTurn(text, record)
                            }}
                        >
                             {t(`ordersManage.repairReturnList.detail.确认接收`)}
                        </Button>
                    )
                }
            },
        },
    ]

    const handleReview = (id, record, passed) => {
        let rejectInfo = ""
        Modal.confirm({
            title: `${record.materialName}`,
            content: (
                <>
                    {passed && <span> {t(`ordersManage.repairReturnList.detail.审核通过`)}</span>}
                    {!passed && (
                        <Input
                            placeholder= {t(`ordersManage.repairReturnList.detail.请输入驳回原因`)}
                            onChange={(e) => {
                                rejectInfo = e.target.value
                            }}
                        />
                    )}
                </>
            ),
            okText: t(`ordersManage.repairReturnList.detail.确定`),
            cancelText: t(`ordersManage.repairReturnList.detail.取消`),
            centered: true,
            onOk() {
                if (!passed && !rejectInfo) {
                    return message.error(t(`ordersManage.repairReturnList.detail.请输入驳回原因`))
                }
                maintainOrderReturnReview({ returnId:id, passed, rejectInfo }).then((res) => {
                    message.success(`${t(`ordersManage.repairReturnList.detail.已`)}${passed ? t(`ordersManage.repairReturnList.detail.通过`) : t(`ordersManage.repairReturnList.detail.驳回`)}`)
                    loadData()
                })
            },
        })
    }

    //确定退料
    const handleConfirmReTurn = (id, record) => {
        Modal.confirm({
            content: `${t(`ordersManage.repairReturnList.detail.确定入库`)}--${record.materialName}?`,
            okText: t(`ordersManage.repairReturnList.detail.确定`),
            cancelText: t(`ordersManage.repairReturnList.detail.取消`),
            centered: true,
            onOk() {
                maintainOrderReturnConfirm(id).then((res) => {
                    message.success(t(`ordersManage.repairReturnList.detail.入库成功`))
                    loadData()
                })
            },
        })
    }

    return (
        <>
            <Modal width={1200} visible={visible} title= {t(`ordersManage.repairReturnList.detail.详情`)} onCancel={() => setVisible(false)} onOk={() => setVisible(false)}>
                <Table size="small" rowKey={(record) => record.id} columns={columns} dataSource={list} pagination={false} scroll={{ x: 1100, y: 660 }} />
            </Modal>
        </>
    )
}
